import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { Faqs } from 'components/Faqs';
import { faq } from 'sections/DigitalTools/LogisticsExplorer/data';
import styles from 'sections/DigitalTools/LogisticsExplorer/components/SectionFaq/SectionFaq.module.scss';

const cn = classNames.bind(styles);

const SectionFaq = (): ReactElement => {
  return (
    <section className={cn('faq')}>
      <div className={cn('container')}>
        <h2 className={cn('faq__title')}>Frequently Asked Questions</h2>
        <div className={cn('faq__list-container')}>
          <Faqs faqsData={faq} />
        </div>
      </div>
    </section>
  );
};

export default SectionFaq;